function productGridFilter() {
    if ($('.js-prod-grid-filter-btn').length) {
        $('.js-prod-grid-filter-btn').on('click', function(e) {
            e.preventDefault();
            
            if ($(this).hasClass('is-active')) {
                return;
            }
            
            const filter = $(this).data('filter');
            if (filter) {
                $('.prod-cat-grid').css('min-height', $('.prod-cat-grid').height());

                // Update filter btn active states
                $('.js-prod-grid-filter-btn').removeClass('is-active');
                $(this).addClass('is-active');

                // Update product rows
                $('.js-prod-grid-section').fadeOut(300);
                setTimeout(() => {
                    $(`.js-prod-grid-section[data-filter="${filter}"]`).css('display','flex').hide().fadeIn(300);
                    $('.prod-cat-grid').css('min-height', 'auto');
                }, 650);
            }
        })
    }
}